import { Injectable, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from 'ng2-webstorage';
import {
  Cart,
  CartProduct,
  Address,
  Customer
} from './models';
import { ConfigService } from '../commons/config.service';
import { serialize } from 'serialijse';


@Injectable()
export class CartService {

  @Output() cartLoaded = new EventEmitter<CartService>();

  public cart: Cart;

  constructor(
    private router: Router,
    private config: ConfigService,
    private storage: LocalStorageService) {
  }

  cloneProduct() {
    let row = new CartProduct();
    row.config = this.cart.currentCartProduct.config;
    row.params = this.cart.currentCartProduct.params;
    row.format = this.cart.currentCartProduct.format;
    row.price = 0;
    // row.productName = 'CLONE: ' +  this.cart.currentCartProduct.productName;
    row.rounded = this.cart.currentCartProduct.rounded;
    if (this.cart.cartProducts.length === 0) {
      row.idRow = 1;
    } else {
      row.idRow = Math.max(...this.cart.cartProducts.map(r => r.idRow)) + 1;
    }
    row.photoOriginal = null;
    row.photoResized = null;
    row.photoBounds = null;
    row.photoID = null;
    row.quantity = 1;
    row.idProduct = this.cart.currentCartProduct.idProduct;

    this.cart.cartProducts.push(row);
    this.saveCart();
    this.cart.idCartRow = row.idRow;
    //console.log('cloneProduct' + this.cart.idCartRow);

    /* Per evitare: Failed to execute 'setItem' on 'Storage': Setting the value of 'ng2-webstorage|cart' exceeded the quota.
       ANCHE photoResized DOVREBBE ESSERE CANCELLATO, DOPO 4-5 IMG IN HD LocalStorage SI RIEMPE */
    this.cart.cartProducts.forEach(r => {
      if (r.idRow !== this.cart.currentCartProduct.idRow) {
        r.photoOriginal = null;
        // r.photoResized = 'deleted';
      }
    });

  }

  addProduct(productId: number, qty: number) {
    let row = new CartProduct();
    if (this.cart.cartProducts.length === 0) {
      row.idRow = 1;
    } else {
      row.idRow = Math.max(...this.cart.cartProducts.map(r => r.idRow)) + 1;
    }
    row.idProduct = productId;
    row.config = this.config.getProductConfigFromIdProduct(productId);
    row.quantity = qty;
    row.rounded = false;
    // row.productName = 'Seleziona prodotto'; // this.config.products.find(r => r.id === productId).name;
    row.price = 0;

    this.cart.cartProducts.push(row);
    this.saveCart();
    this.cart.idCartRow = row.idRow;
    ////console.log('addProduct' + this.cart.idCartRow + ' - productId:' + productId);

    /* Per evitare: Failed to execute 'setItem' on 'Storage': Setting the value of 'ng2-webstorage|cart' exceeded the quota.
       ANCHE photoResized DOVREBBE ESSERE CANCELLATO, DOPO 4-5 IMG IN HD LocalStorage SI RIEMPE */
    this.cart.cartProducts.forEach(r => {
      if (r.idRow !== this.cart.currentCartProduct.idRow) {
        r.photoOriginal = null;
        // r.photoResized = 'deleted';
      }
    });
  }

  removeCartRow(idRow: Number) {
    //console.log('removeCartRow' + idRow);
    this.cart.cartProducts = this.cart.cartProducts.filter(r => r.idRow !== idRow);
    this.saveCart();
  }

  saveCart() {
    //console.log('saveCart');
    this.storage.store('cart', serialize(this.cart));
  }

  public refreshQuantity(idRow: Number, quantity: number) {
    let currentRow = this.cart.cartProducts.filter(r => r.idRow === idRow)[0];
    if (currentRow != null) {
      if (quantity < 1) {
        this.removeCartRow(idRow);
      }
      currentRow.quantity = quantity;
      //console.log('refreshQuantity' + idRow + ' - ' + quantity);
    }
    this.saveCart();
  }

  public cartCheckProducts(redirectControl = true) {
    //console.log('cartCheckProducts');
    // Aggiornare solo all'occorrenza per forzare il reset del carrello
    let currentVersionDate = 20170919;

    if (!this.cart
      || (this.cart.version === null || this.cart.version !== currentVersionDate)
    ) {
      this.cart = new Cart();
      this.cart.version = currentVersionDate;
      this.cart.checkoutStepIndex = 1;
      this.cart.shipmentNations = this.config.shipmentNations;
      this.cart.SelDeliveryOption = this.config.deliveryOptions[0];
      this.cart.deliveryPricesItaly = this.config.deliveryPricesItaly;
      this.cart.deliveryPricesEXT = this.config.deliveryPricesEXT;
      this.cart.deliveryFissi = this.config.deliveryFissi;
    }

    if (!this.cart.cartProducts) {
      this.cart.cartProducts = [];
    }
    if (!this.cart.customer) {
      this.cart.customer = new Customer();
    }

    if (!this.cart.billing) {
      this.cart.billing = new Customer();
    }

    if (!this.cart.shipmentAddress) {
      this.cart.shipmentAddress = new Address();
      this.cart.shipmentAddress.Country = 'IT';
    }
    if (!this.cart.billingAddress) {
      this.cart.billingAddress = new Address();
    }
    if (!this.cart.SelDeliveryOption) {
      this.cart.SelDeliveryOption = this.config.deliveryOptions[0];
    }

    //console.log(this.cart.SelDeliveryOption.id);

    if (this.cart.idCartRow === null) {
      this.cart.idCartRow = 1;
    }


    if (!this.cart.cartProducts || this.cart.cartProducts.length === 0 || !this.cart.currentCartProduct) {
      ////console.log('no cartProducts - redirect to upload-photo + addProduct() in upload-photo-component');
      this.addProduct(this.config.products[0].id, 1);
      if (redirectControl) {
        this.router.navigate(['/upload-photo']);
      }
    } else {
      if (this.cart.currentCartProduct.params != null) {
        if (this.cart.cartProducts.length === 0 || this.cart.currentCartProduct.params.length === 0) {
          if (redirectControl) {
            this.router.navigate(['/upload-photo']);
          }
        } else
          if (!this.cart.currentCartProduct) {
            this.cart.idCartRow = this.cart.cartProducts[this.cart.cartProducts.length - 1].idRow;
          }
      }
    }

  }

  public cartCheckCROPPED() {
    if (this.cart.cartProducts.some(this.cropMissing)) {
      this.router.navigate(['/slide-parameter/Formato']);
      window.scrollTo(0, 0);
      $('html, body').animate({ scrollTop: 0 }, 'slow');
    }
  }
  public cropMissing(element: CartProduct, index, array) {
    return !element.photoResized;
  }


  public setFormat(format: any) {

    // SE CAMBIO FORMATO CANCELLO IL RITAGLIO PERCHè NON PIù VALIDO
    this.cart.currentCartProduct.photoResized = null;
    //console.log('setFormat - cambio formato - currentCartProduct.photoResized = null');
    this.cart.formatoSelected = true;

    this.cart.currentCartProduct.format = format.split('|')[0] + '|' + format.split('|')[1];
    this.setPesoVolumITA(format);
    this.setPesoVolumEXT(format);
  }

  private setPesoVolumITA(format: string) {
    let width: number = Number(format.split('|')[2]);
    let height: number = Number(format.split('|')[3]);
    this.cart.currentCartProduct.pesoVolumITA = 0;

    if (this.config.deliveryFissi.indexOf(this.cart.currentCartProduct.productName) === -1) {
      this.cart.currentCartProduct.pesoVolumITA = (width + 8) * (height + 8) * 8 / 3333;
    }
  }

  private setPesoVolumEXT(format: string) {
    let width: number = Number(format.split('|')[2]);
    let height: number = Number(format.split('|')[3]);
    this.cart.currentCartProduct.pesoVolumEXT = (width) * (height) * 8 / 5000;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/commons/cart.service.ts